import { SvgIcon, SxProps } from "@mui/material";

import SvgXMarkIcon from "jsx:../../../Images/Icons/FontAwesome/light/xmark.svg";

export function CloseIcon(props: SxProps) {
    return (
        <SvgIcon
            component={SvgXMarkIcon}
            inheritViewBox
            sx={{
                width: "24px",
                height: "24px",
                ...props,
            }}
        />
    );
}
